import {Component} from "react";
import "./AllServices.css";
import ContactForm from "../ContactForm/ContactForm";
import zh from "../../media/zapatos_horizontal.jpg";
import tns from "../../media/todos_nuestros_servicios.png";

export default class AllServices extends Component{
    render(){
        return(
            <div className="allServices">
                <div className="banner">
                    <img src={tns} alt=""/>
                </div>
                <div className="container allServices-container">
                    <div className="allServices-list">
                        <div className="allServices-element">
                            <div className="allServices-title">
                                Tapas y tacones
                            </div>
                            <ul>
                                <li>Tapas de perno para zapatillas</li>
                                <li>Tapas antiderrapantes y silenciosas de hule</li>
                                <li>Tapas para botas</li>
                                <li>Tapas para zapato de vestir</li>
                                <li>Tacones para zapatillas.</li>
                                <li>Tacones para zapato de Vestir</li>
                                <li>Tacones de hule</li>
                                <li>Tacón Cubano</li>
                                <li>Forrado de tacones</li>
                                <li>Pintado de tacones</li>
                                <li>Protectores de hule y metal</li>
                            </ul>
                        </div>
                        <div className="allServices-element">
                            <div className="allServices-title">
                                Costuras y detalles
                            </div>
                            <ul>
                                <li>Costura de bolsas, mochilas, cinturones,y otros accesorios</li>
                                <li>Adaptación, reparación y cambio de cierres</li>
                                <li>Cambio de broches.</li>
                                <li>Cambio de cintas y asas</li>
                                <li>Modificación y adaptaciónde accesorios</li>
                                <li>Cambio de adornos.</li>
                                <li>Pegado de plantillas</li>
                                <li>Plantillas de piel para zapatos y zapatillas</li>
                            </ul>
                        </div>
                        <div className="allServices-element">
                            <div className="allServices-title">
                                Ortopedia
                            </div>
                            <ul>
                                <li>Elaboración de plantillas ortopédicas</li>
                                <li>Aumentos a la medida</li>
                                <li>Taloneras niveladoras a la medida</li>
                            </ul>
                        </div>
                    </div>
                    <img src={zh} alt=""/>
                    <div className="allServices-list">
                        <div className="allServices-element">
                            <div className="allServices-title">
                                Suelas
                            </div>
                            <ul>
                                <li>Suelas de cuero y hule para zapatos de dama y <br/>caballero.</li>
                                <li>Suelas para tenis</li>
                                <li>Suelas para botas vaqueras</li>
                                <li>Suelas de piso</li>
                                <li>Suelas de cámara de avión</li>
                                <li>Media suela antiderrapante (Doble Vida)</li>
                                <li>Costura y pegado de suelas</li>
                            </ul>
                        </div>
                        <div className="allServices-element">
                            <div className="allServices-title">
                                Boleado, pintura y lavado
                            </div>
                            <ul>
                                <li>Boleado de zapatos</li>
                                <li>Limpieza de Tenis</li>
                                <li>Pintado de Zapatos y artículos de piel (color igual o diferente)</li>
                                <li>Pintado de Chamarras</li>
                                <li>Restaurado de zapatos de gamuza, ante, nobuck y pieles grasas</li>
                                <li>Aclarado de Suelas</li>
                            </ul>
                        </div>
                        <div className="allServices-element">
                            <div className="allServices-title">
                                Hormado
                            </div>
                            <ul>
                                <li>Hormado de largo*, ancho y empeine del zapato.</li>
                                <li>Hormado para el juanete</li>
                                <li>Asentar y suavizar filos que provoquen heridas y ampollas.</li>
                            </ul>
                        </div>
                        <div className="allServices-element">
                            <div className="allServices-title">
                                Otros servicios
                            </div>
                            <ul>
                                <li>Colocación de almohadillas metatarsales</li>
                                <li>Taloneras de ajuste para zapatillas o zapatos</li>
                                <li>Virones y/o cuñas</li>
                                <li>Punteras</li>
                            </ul>
                        </div>
                    </div>
                </div>
                {<ContactForm/>}
            </div>
        )
    }
}